const SocketChatsKeys = {
  join_chat: `join_chat`,
  join_chat_group: `join_chat_group`,
  request_user_group_chat: `request_user_group_chat`,
  check_team_contact_request: `check_team_contact_request`,
  check_dept_contact_request: `check_dept_contact_request`,
  user_left_chat_group: `user_left_chat_group`,
  leave_chat: `leave_chat`,
  chat_message_history: `chat_message_history`,
  new_chat_message: `new_chat_message`,
  profile_online: `profile_online`,
  profile_offline: `profile_offline`,
  chat_delete_messages: `chat_delete_messages`,
  mark_read_chat: `mark_read_chat`,
  chat_block_profile: `chat_block_profile`,
  profile_typing: `profile_typing`,
  mark_read_chat_group_message: `mark_read_chat_group_message`,
  chat_clear_messages: `chat_clear_messages`,
  chat_group_message_history: `chat_group_message_history`,
  new_chat_group_message: `new_chat_group_message`,
  user_exit_chat_group: `user_exit_chat_group`,
  chat_mute_notification: `chat_mute_notification`,
  send_chat_message: `send_chat_message`,
  send_dept_chat_message: `send_dept_chat_message`,
  send_chat_group_message: `send_chat_group_message`,
   chat_message_list: `chat_message_list`,
};

export default SocketChatsKeys;
